(function () {

  'use strict';

  /**
   * @author - Chester Rivas
   * @description - extends bootstrap popover component to be able to pass in a partial view or a directive or inline markup
   */
  angular.module('ute.ui')

  /**
   * service for utePopover directive that will allow access to the scope of all the directives
   */
    .factory('utePopoverFactory', function () {

      var utePopoverFactory = {

        /**
         * an array of the scope of currently opened popovers
         */
        utePopoverScopes: [],

        /**
         * saves the $scope instance and pushes to rgPopoverScope array
         */
        popCurrentPopover: function (popOverScope) {
          utePopoverFactory.utePopoverScopes = utePopoverFactory.utePopoverScopes || [];
          _.each(utePopoverFactory.utePopoverScopes, function (eachPopOver, index) {
            if (angular.equals(popOverScope, eachPopOver)) {
              utePopoverFactory.utePopoverScopes.slice(index, 1);
            }
          });
        },

        /**
         * pushes the passed in $scope instance and utePopoverFactory level array
         */
        pushCurrentPopover: function (popOverScope) {
          utePopoverFactory.utePopoverScopes = utePopoverFactory.utePopoverScopes || [];
          utePopoverFactory.utePopoverScopes.push(popOverScope);
        },

        /**
         * hides all popovers
         */
        hideAllOpenPopovers: function () {

          _.each(utePopoverFactory.utePopoverScopes, function (eachPopOver) {
            eachPopOver.hide();
          });

          utePopoverFactory.utePopoverScopes = [];

        },

        /**
         * shows all popovers
         */
        showAllOpenPopovers: function () {

          _.each(utePopoverFactory.utePopoverScopes, function (eachPopOver) {
            eachPopOver.show();
          });

        }
      };

      return utePopoverFactory;

    });

})();
